// // import { Footer } from '@/components'
// import { useLayoutEffect } from "react";
// import LayoutsNavbar from "../../components/LayoutsNavbar/LayoutsNavbar";
// import Footer1 from "../../components/common/Footer1";
// import FAQs from "./FAQs";
// import HelpLinks from "./HelpLinks";
// import Hero from "./Hero";
// import SupportCenter from "./SupportCenter";

// //data
// import { helpLinks } from "./data";

// const Help = () => {
// 	useLayoutEffect(()=>{
// 		window.scrollTo(0,0)
// 	},[])
//   return (
//     <>
//       <div>
//         <LayoutsNavbar />
//         <Hero />
//         <section className="py-20 relative">
//           <div className="container">
//             <div className="grid lg:grid-cols-3 grid-cols-1 gap-6">
//               <div className="lg:col-span-2 cols-span-1">
//                 <HelpLinks helpLinks={helpLinks} />

//                 {/* <FAQs /> */}
//               </div>
//               <SupportCenter />
//             </div>
//           </div>
//         </section>
//         <Footer1 />
//       </div>
//     </>
//   );
// };

// export default Help;


import React, { useState, useEffect } from 'react';
import { Users, MessageCircle, BarChart3, Shield, Video, Zap, Target, Eye, Heart, Star, ArrowRight, CheckCircle } from 'lucide-react';
import LayoutsNavbar from '../../components/LayoutsNavbar/LayoutsNavbar';
import Footer from '../../components/partials/dashboard/FooterStyle/footer';
import Footer1 from '../../components/common/Footer1';
import ScrollToTop from '../../components/scroll-to-top/ScrollToTop';

const AboutUsPage = () => {
  const [isVisible, setIsVisible] = useState({});

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(prev => ({ ...prev, [entry.target.id]: true }));
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = document.querySelectorAll('.animate-on-scroll');
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  const timelineData = [
    {
      year: "2023",
      title: "The Beginning",
      description: "Started with a simple idea — unify business chats across all major platforms"
    },
    {
      year: "2024",
      title: "Growth & Trust",
      description: "Reached 500+ business users and launched advanced automation features"
    },
    {
      year: "2025",
      title: "Innovation Milestone",
      description: "Launched secure multi-platform dashboard with AI-powered insights"
    }
  ];

  const features = [
    {
      icon: <MessageCircle className="w-8 h-8" />,
      title: "Multi-Platform Integration",
      description: "Instagram, Facebook, WhatsApp — all in one dashboard"
    },
    {
      icon: <Zap className="w-8 h-8" />,
      title: "Automated Chat System",
      description: "Smart automation that saves time and improves response rates"
    },
    {
      icon: <BarChart3 className="w-8 h-8" />,
      title: "Real-time Analytics",
      description: "Deep insights into customer engagement and performance metrics"
    },
    {
      icon: <Shield className="w-8 h-8" />,
      title: "Secure 2FA Login",
      description: "Enterprise-grade security with two-factor authentication"
    },
    {
      icon: <Video className="w-8 h-8" />,
      title: "Google Meet Integration",
      description: "Seamless video calls and external platform connectivity"
    },
    {
      icon: <Users className="w-8 h-8" />,
      title: "Team Collaboration",
      description: "Built for teams with role-based access and workflow management"
    }
  ];

  const values = [
    {
      icon: <Zap className="w-6 h-6" />,
      title: "Innovation",
      description: "Pushing boundaries with cutting-edge technology"
    },
    {
      icon: <Eye className="w-6 h-6" />,
      title: "Transparency",
      description: "Open communication and honest business practices"
    },
    {
      icon: <Shield className="w-6 h-6" />,
      title: "Security",
      description: "Your data protection is our top priority"
    },
    {
      icon: <Heart className="w-6 h-6" />,
      title: "Customer-First",
      description: "Every decision starts with our users' needs"
    }
  ];

  const trustedLogos = [
    "TechCorp", "InnovateLab", "GrowthHub", "ScaleUp", "CloudSync", "DataFlow"
  ];

  return (
    <div>
       <ScrollToTop />
        <LayoutsNavbar />
      <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 mt-[86px]">
        {/* Hero Section */}
      <section className="relative min-h-screen overflow-hidden bg-gradient-to-br from-[#50B5FF]/8 to-purple-100/40">
      {/* Background decorative elements */}
      <div className="absolute inset-0">
        <div className="absolute top-20 left-10 w-72 h-72 bg-[#50B5FF]/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-purple-200/20 rounded-full blur-3xl"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gradient-to-r from-[#50B5FF]/5 to-purple-100/10 rounded-full blur-3xl"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-6 py-24 lg:py-32 flex items-center min-h-screen">
        <div className="w-full text-center animate-on-scroll" id="hero">
          <h1 className={`text-5xl lg:text-7xl font-bold mb-8 transition-all duration-1000 ${isVisible.hero ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <span className="block bg-gradient-to-r from-[#50B5FF] via-blue-500 to-purple-500 bg-clip-text text-transparent leading-tight">
              Unite. Automate. Dominate.
            </span>
            <span className="block text-slate-800 mt-4 text-4xl lg:text-5xl">
              Your Communication Empire
            </span>
          </h1>
          
          <p className={`text-xl lg:text-2xl mb-12 max-w-4xl mx-auto leading-relaxed text-slate-700 transition-all duration-1000 delay-300 ${isVisible.hero ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            We help brands automate, manage, and grow conversations across Instagram, Facebook, and WhatsApp with powerful AI-driven solutions.
          </p>

          {/* <div className={`flex flex-col sm:flex-row gap-6 justify-center mb-16 transition-all duration-1000 delay-500 ${isVisible.hero ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <button className="group bg-gradient-to-r from-[#50B5FF] to-blue-500 text-white px-10 py-4 rounded-full font-semibold text-lg hover:shadow-2xl hover:shadow-[#50B5FF]/25 transform hover:-translate-y-2 hover:scale-105 transition-all duration-300 relative overflow-hidden">
              <span className="relative z-10">Get Started Today</span>
              <div className="absolute inset-0 bg-gradient-to-r from-blue-500 to-[#50B5FF] opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            </button>
            <button className="group border-2 border-[#50B5FF] text-[#50B5FF] px-10 py-4 rounded-full font-semibold text-lg hover:bg-[#50B5FF] hover:text-white hover:shadow-xl hover:shadow-[#50B5FF]/20 transform hover:-translate-y-2 hover:scale-105 transition-all duration-300">
              <span className="flex items-center justify-center gap-2">
                Watch Demo
                <svg className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </span>
            </button>
          </div> */}

          {/* Feature highlights */}
          <div className={`grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto transition-all duration-1000 delay-700 ${isVisible.hero ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <div className="bg-white/70 backdrop-blur-sm rounded-2xl p-6 border border-[#50B5FF]/20 hover:border-[#50B5FF]/40 hover:shadow-lg hover:shadow-[#50B5FF]/10 transition-all duration-300">
              <div className="w-12 h-12 bg-gradient-to-r from-[#50B5FF] to-blue-500 rounded-xl flex items-center justify-center mb-4 mx-auto">
                <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M2 5a2 2 0 012-2h7a2 2 0 012 2v4a2 2 0 01-2 2H9l-3 3v-3H4a2 2 0 01-2-2V5z" />
                  <path d="M15 7v2a4 4 0 01-4 4H9.828l-1.766 1.767c.28.149.599.233.938.233h2l3 3v-3h2a2 2 0 002-2V9a2 2 0 00-2-2h-1z" />
                </svg>
              </div>
              <h3 className="font-semibold text-slate-800 mb-2">Multi-Platform</h3>
              <p className="text-slate-600 text-sm">Connect Instagram, Facebook & WhatsApp</p>
            </div>

            <div className="bg-white/70 backdrop-blur-sm rounded-2xl p-6 border border-purple-200/50 hover:border-purple-300/70 hover:shadow-lg hover:shadow-purple-200/20 transition-all duration-300">
              <div className="w-12 h-12 bg-gradient-to-r from-purple-400 to-purple-500 rounded-xl flex items-center justify-center mb-4 mx-auto">
                <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z" clipRule="evenodd" />
                </svg>
              </div>
              <h3 className="font-semibold text-slate-800 mb-2">AI Automation</h3>
              <p className="text-slate-600 text-sm">Smart responses & workflow automation</p>
            </div>

            <div className="bg-white/70 backdrop-blur-sm rounded-2xl p-6 border border-blue-200/50 hover:border-blue-300/70 hover:shadow-lg hover:shadow-blue-200/20 transition-all duration-300">
              <div className="w-12 h-12 bg-gradient-to-r from-blue-400 to-blue-500 rounded-xl flex items-center justify-center mb-4 mx-auto">
                <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="font-semibold text-slate-800 mb-2">Growth Analytics</h3>
              <p className="text-slate-600 text-sm">Track engagement & conversion metrics</p>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom gradient fade */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-white/90 to-transparent"></div>
    </section>

        {/* Mission & Vision */}
        <section className="py-20 px-6 bg-white">
          <div className="max-w-7xl mx-auto">
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              <div className="animate-on-scroll" id="mission">
                <div className={`transition-all duration-1000 ${isVisible.mission ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'}`}>
                  <div className="flex items-center mb-6">
                    <Target className="w-8 h-8 text-[#50B5FF] mr-4" />
                    <h2 className="text-4xl font-bold text-gray-800">Our Mission</h2>
                  </div>
                  <p className="text-lg text-gray-600 leading-relaxed">
                    Our mission is to simplify and scale business communication by integrating powerful platforms in one centralized dashboard. From message automation to analytics, we empower brands to engage their audience effortlessly.
                  </p>
                </div>
              </div>
              <div className="animate-on-scroll" id="vision">
                <div className={`transition-all duration-1000 delay-300 ${isVisible.vision ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'}`}>
                  <div className="flex items-center mb-6">
                    <Eye className="w-8 h-8 text-[#50B5FF] mr-4" />
                    <h2 className="text-4xl font-bold text-gray-800">Our Vision</h2>
                  </div>
                  <p className="text-lg text-gray-600 leading-relaxed">
                    To be the most trusted all-in-one communication platform for businesses worldwide, combining security, automation, and meaningful engagement.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* What We Do */}
        <section className="py-20 px-6 bg-white">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-16 animate-on-scroll" id="features">
              <h2 className={`text-4xl lg:text-5xl font-bold text-gray-800 mb-6 transition-all duration-1000 ${isVisible.features ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
                What We Do
              </h2>
              <p className={`text-xl text-gray-600 max-w-3xl mx-auto transition-all duration-1000 delay-300 ${isVisible.features ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
                Comprehensive tools designed to transform how businesses communicate with their customers
              </p>
            </div>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {features.map((feature, index) => (
                <div
                  key={index}
                  className={`bg-gradient-to-br from-slate-50 to-blue-50 p-8 rounded-2xl shadow-lg hover:shadow-2xl transform hover:-translate-y-2 transition-all duration-500 border border-blue-100 animate-on-scroll`}
                  id={`feature-${index}`}
                  style={{ transitionDelay: `${index * 100}ms` }}
                >
                  <div className={`transition-all duration-1000 ${isVisible[`feature-${index}`] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
                    <div className="text-[#50B5FF] mb-4">{feature.icon}</div>
                    <h3 className="text-xl font-bold text-gray-800 mb-3">{feature.title}</h3>
                    <p className="text-gray-600">{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Our Story Timeline */}
        <section className="py-20 px-6 bg-gradient-to-r from-slate-100 to-blue-100">
          <div className="max-w-5xl mx-auto">
            <div className="text-center mb-16 animate-on-scroll" id="timeline">
              <h2 className={`text-4xl lg:text-5xl font-bold text-gray-800 mb-6 transition-all duration-1000 ${isVisible.timeline ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
                Our Journey
              </h2>
            </div>
            <div className="relative">
              <div className="absolute left-1/2 transform -translate-x-1/2 h-full w-1 bg-[#50B5FF] rounded-full"></div>
              {timelineData.map((item, index) => (
                <div
                  key={index}
                  className={`relative flex items-center mb-12 ${index % 2 === 0 ? 'flex-row' : 'flex-row-reverse'} animate-on-scroll`}
                  id={`timeline-${index}`}
                >
                  <div className={`w-1/2 ${index % 2 === 0 ? 'pr-8 text-right' : 'pl-8 text-left'} transition-all duration-1000 ${isVisible[`timeline-${index}`] ? 'opacity-100 translate-x-0' : `opacity-0 ${index % 2 === 0 ? 'translate-x-10' : '-translate-x-10'}`}`}>
                    <div className="bg-white p-6 rounded-2xl shadow-lg border border-blue-200">
                      <div className="text-2xl font-bold text-[#50B5FF] mb-2">{item.year}</div>
                      <h3 className="text-xl font-bold text-gray-800 mb-2">{item.title}</h3>
                      <p className="text-gray-600">{item.description}</p>
                    </div>
                  </div>
                  <div className="absolute left-1/2 transform -translate-x-1/2 w-4 h-4 bg-[#50B5FF] rounded-full border-4 border-white shadow-lg"></div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Why Choose Us Section */}
        <section className="py-20 px-6 bg-white overflow-hidden">
          <div className="max-w-7xl mx-auto">
            <div className="grid lg:grid-cols-2 gap-16 items-center">
              <div className="animate-on-scroll" id="why-choose">
                <div className={`transition-all duration-1000 ${isVisible['why-choose'] ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'}`}>
                  <h2 className="text-4xl lg:text-5xl font-bold text-gray-800 mb-8">
                    Why Choose Our Platform?
                  </h2>
                  <div className="space-y-6">
                    <div className="flex items-start space-x-4">
                      <div className="flex-shrink-0 w-8 h-8 bg-green-500 rounded-full flex items-center justify-center">
                        <CheckCircle className="w-5 h-5 text-white" />
                      </div>
                      <div>
                        <h3 className="text-xl font-bold text-gray-800 mb-2">500+ Active Businesses</h3>
                        <p className="text-gray-600">Trusted by companies worldwide for their communication needs</p>
                      </div>
                    </div>
                    <div className="flex items-start space-x-4">
                      <div className="flex-shrink-0 w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center">
                        <CheckCircle className="w-5 h-5 text-white" />
                      </div>
                      <div>
                        <h3 className="text-xl font-bold text-gray-800 mb-2">99.9% Uptime</h3>
                        <p className="text-gray-600">Reliable infrastructure ensuring your business never stops</p>
                      </div>
                    </div>
                    <div className="flex items-start space-x-4">
                      <div className="flex-shrink-0 w-8 h-8 bg-purple-500 rounded-full flex items-center justify-center">
                        <CheckCircle className="w-5 h-5 text-white" />
                      </div>
                      <div>
                        <h3 className="text-xl font-bold text-gray-800 mb-2">24/7 Support</h3>
                        <p className="text-gray-600">Round-the-clock assistance from our expert team</p>
                      </div>
                    </div>
                    <div className="flex items-start space-x-4">
                      <div className="flex-shrink-0 w-8 h-8 bg-orange-500 rounded-full flex items-center justify-center">
                        <CheckCircle className="w-5 h-5 text-white" />
                      </div>
                      <div>
                        <h3 className="text-xl font-bold text-gray-800 mb-2">Enterprise Security</h3>
                        <p className="text-gray-600">Bank-grade encryption protecting your sensitive data</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="animate-on-scroll" id="stats-visual">
                <div className={`transition-all duration-1000 delay-300 ${isVisible['stats-visual'] ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'}`}>
                  <svg viewBox="0 0 400 400" className="w-full h-auto max-w-md mx-auto">
                    {/* Background circles */}
                    <defs>
                      <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" style={{ stopColor: '#50B5FF', stopOpacity: 0.2 }} />
                        <stop offset="100%" style={{ stopColor: '#3B82F6', stopOpacity: 0.4 }} />
                      </linearGradient>
                      <linearGradient id="gradient2" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" style={{ stopColor: '#8B5CF6', stopOpacity: 0.3 }} />
                        <stop offset="100%" style={{ stopColor: '#EC4899', stopOpacity: 0.2 }} />
                      </linearGradient>
                      <filter id="glow">
                        <feGaussianBlur stdDeviation="3" result="coloredBlur" />
                        <feMerge>
                          <feMergeNode in="coloredBlur" />
                          <feMergeNode in="SourceGraphic" />
                        </feMerge>
                      </filter>
                    </defs>

                    {/* Animated background elements */}
                    <circle cx="200" cy="200" r="180" fill="url(#gradient1)" opacity="0.3">
                      <animateTransform
                        attributeName="transform"
                        type="rotate"
                        values="0 200 200;360 200 200"
                        dur="20s"
                        repeatCount="indefinite"
                      />
                    </circle>

                    <circle cx="200" cy="200" r="120" fill="url(#gradient2)" opacity="0.4">
                      <animateTransform
                        attributeName="transform"
                        type="rotate"
                        values="360 200 200;0 200 200"
                        dur="15s"
                        repeatCount="indefinite"
                      />
                    </circle>

                    {/* Central hub */}
                    <circle cx="200" cy="200" r="60" fill="#50B5FF" filter="url(#glow)">
                      <animate attributeName="r" values="55;65;55" dur="3s" repeatCount="indefinite" />
                    </circle>

                    {/* Platform icons around the hub */}
                    <g transform="translate(200,120)">
                      <circle r="25" fill="#E1306C" />
                      <text x="0" y="8" textAnchor="middle" fill="white" fontSize="12" fontWeight="bold">IG</text>
                      <animateTransform
                        attributeName="transform"
                        type="rotate"
                        values="0 0 80;360 0 80"
                        dur="10s"
                        repeatCount="indefinite"
                      />
                    </g>

                    <g transform="translate(280,200)">
                      <circle r="25" fill="#1877F2" />
                      <text x="0" y="8" textAnchor="middle" fill="white" fontSize="12" fontWeight="bold">FB</text>
                      <animateTransform
                        attributeName="transform"
                        type="rotate"
                        values="0 -80 0;360 -80 0"
                        dur="12s"
                        repeatCount="indefinite"
                      />
                    </g>

                    <g transform="translate(200,280)">
                      <circle r="25" fill="#25D366" />
                      <text x="0" y="8" textAnchor="middle" fill="white" fontSize="10" fontWeight="bold">WA</text>
                      <animateTransform
                        attributeName="transform"
                        type="rotate"
                        values="0 0 -80;360 0 -80"
                        dur="8s"
                        repeatCount="indefinite"
                      />
                    </g>

                    <g transform="translate(120,200)">
                      <circle r="25" fill="#FF6B35" />
                      <text x="0" y="8" textAnchor="middle" fill="white" fontSize="12" fontWeight="bold">AI</text>
                      <animateTransform
                        attributeName="transform"
                        type="rotate"
                        values="0 80 0;360 80 0"
                        dur="14s"
                        repeatCount="indefinite"
                      />
                    </g>

                    {/* Connection lines */}
                    <line x1="200" y1="140" x2="200" y2="200" stroke="#50B5FF" strokeWidth="3" opacity="0.6">
                      <animate attributeName="opacity" values="0.3;1;0.3" dur="2s" repeatCount="indefinite" />
                    </line>
                    <line x1="260" y1="200" x2="200" y2="200" stroke="#50B5FF" strokeWidth="3" opacity="0.6">
                      <animate attributeName="opacity" values="0.3;1;0.3" dur="2.5s" repeatCount="indefinite" />
                    </line>
                    <line x1="200" y1="260" x2="200" y2="200" stroke="#50B5FF" strokeWidth="3" opacity="0.6">
                      <animate attributeName="opacity" values="0.3;1;0.3" dur="1.8s" repeatCount="indefinite" />
                    </line>
                    <line x1="140" y1="200" x2="200" y2="200" stroke="#50B5FF" strokeWidth="3" opacity="0.6">
                      <animate attributeName="opacity" values="0.3;1;0.3" dur="2.2s" repeatCount="indefinite" />
                    </line>

                    {/* Central text */}
                    <text x="200" y="205" textAnchor="middle" fill="white" fontSize="16" fontWeight="bold">HUB</text>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Our Values */}
        <section className="py-20 px-6 bg-gradient-to-br from-slate-50 to-blue-50">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-16 animate-on-scroll" id="values">
              <h2 className={`text-4xl lg:text-5xl font-bold text-gray-800 mb-6 transition-all duration-1000 ${isVisible.values ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
                Our Values
              </h2>
            </div>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
              {values.map((value, index) => (
                <div
                  key={index}
                  className={`text-center p-6 bg-white rounded-2xl shadow-lg hover:shadow-2xl transform hover:-translate-y-2 transition-all duration-500 animate-on-scroll`}
                  id={`value-${index}`}
                >
                  <div className={`transition-all duration-1000 ${isVisible[`value-${index}`] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} style={{ transitionDelay: `${index * 100}ms` }}>
                    <div className="inline-flex items-center justify-center w-12 h-12 bg-[#50B5FF] bg-opacity-10 rounded-full text-[#50B5FF] mb-4">
                      {value.icon}
                    </div>
                    <h3 className="text-xl font-bold text-gray-800 mb-3">{value.title}</h3>
                    <p className="text-gray-600">{value.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Trusted By */}
        <section className="py-20 px-6 bg-white">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-16 animate-on-scroll" id="trusted">
              <h2 className={`text-4xl lg:text-5xl font-bold text-gray-800 mb-6 transition-all duration-1000 ${isVisible.trusted ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
                Trusted By Industry Leaders
              </h2>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8 items-center">
              {trustedLogos.map((logo, index) => (
                <div
                  key={index}
                  className={`text-center p-6 bg-gradient-to-br from-slate-50 to-blue-50 rounded-2xl border border-blue-100 hover:shadow-lg transform hover:-translate-y-1 transition-all duration-300 animate-on-scroll`}
                  id={`logo-${index}`}
                >
                  <div className={`transition-all duration-1000 ${isVisible[`logo-${index}`] ? 'opacity-100 scale-100' : 'opacity-0 scale-90'}`} style={{ transitionDelay: `${index * 100}ms` }}>
                    <div className="text-gray-400 font-bold text-lg">{logo}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Success Stories & Analytics */}
        {/* <section className="py-20 px-6 bg-gradient-to-br from-indigo-900 via-purple-900 to-pink-900 text-white relative overflow-hidden">
        <div className="absolute inset-0 bg-black bg-opacity-30"></div>
        <div className="relative max-w-7xl mx-auto">
          <div className="text-center mb-16 animate-on-scroll" id="success">
            <h2 className={`text-4xl lg:text-5xl font-bold mb-6 transition-all duration-1000 ${isVisible.success ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
              Driving Real Results
            </h2>
            <p className={`text-xl opacity-90 max-w-3xl mx-auto transition-all duration-1000 delay-300 ${isVisible.success ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
              See how businesses are transforming with our platform
            </p>
          </div>
          
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div className="animate-on-scroll" id="metrics">
              <div className={`transition-all duration-1000 ${isVisible.metrics ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'}`}>
                <div className="grid grid-cols-2 gap-8">
                  <div className="text-center p-6 bg-white bg-opacity-10 backdrop-blur-lg rounded-2xl border border-white border-opacity-20">
                    <div className="text-4xl font-bold text-yellow-300 mb-2">98%</div>
                    <div className="text-sm opacity-80">Response Rate</div>
                  </div>
                  <div className="text-center p-6 bg-white bg-opacity-10 backdrop-blur-lg rounded-2xl border border-white border-opacity-20">
                    <div className="text-4xl font-bold text-green-300 mb-2">3.2x</div>
                    <div className="text-sm opacity-80">Faster Resolution</div>
                  </div>
                  <div className="text-center p-6 bg-white bg-opacity-10 backdrop-blur-lg rounded-2xl border border-white border-opacity-20">
                    <div className="text-4xl font-bold text-blue-300 mb-2">85%</div>
                    <div className="text-sm opacity-80">Cost Reduction</div>
                  </div>
                  <div className="text-center p-6 bg-white bg-opacity-10 backdrop-blur-lg rounded-2xl border border-white border-opacity-20">
                    <div className="text-4xl font-bold text-pink-300 mb-2">24/7</div>
                    <div className="text-sm opacity-80">Automation</div>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="animate-on-scroll" id="growth-visual">
              <div className={`transition-all duration-1000 delay-300 ${isVisible['growth-visual'] ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'}`}>
                <svg viewBox="0 0 400 300" className="w-full h-auto">
                  <defs>
                    <linearGradient id="chartGradient" x1="0%" y1="0%" x2="0%" y2="100%">
                      <stop offset="0%" style={{stopColor:'#50B5FF', stopOpacity:0.8}} />
                      <stop offset="100%" style={{stopColor:'#50B5FF', stopOpacity:0.1}} />
                    </linearGradient>
                  </defs>
                  
                  
                  <g stroke="rgba(255,255,255,0.1)" strokeWidth="1">
                    <line x1="50" y1="50" x2="350" y2="50" />
                    <line x1="50" y1="100" x2="350" y2="100" />
                    <line x1="50" y1="150" x2="350" y2="150" />
                    <line x1="50" y1="200" x2="350" y2="200" />
                    <line x1="50" y1="250" x2="350" y2="250" />
                  </g>
                  
                  
                  <path
                    d="M 50 220 L 100 200 L 150 180 L 200 120 L 250 100 L 300 80 L 350 60"
                    fill="none"
                    stroke="#50B5FF"
                    strokeWidth="4"
                    strokeLinecap="round"
                  >
                    <animate
                      attributeName="stroke-dasharray"
                      values="0 1000;300 0"
                      dur="3s"
                      fill="freeze"
                    />
                  </path>
                  
                  
                  <path
                    d="M 50 220 L 100 200 L 150 180 L 200 120 L 250 100 L 300 80 L 350 60 L 350 250 L 50 250 Z"
                    fill="url(#chartGradient)"
                    opacity="0.6"
                  >
                    <animate
                      attributeName="opacity"
                      values="0;0.6"
                      dur="3s"
                      fill="freeze"
                    />
                  </path>
                  
                  
                  <circle cx="50" cy="220" r="5" fill="#FFD700">
                    <animate attributeName="r" values="0;5" dur="1s" begin="1s" fill="freeze"/>
                  </circle>
                  <circle cx="150" cy="180" r="5" fill="#FFD700">
                    <animate attributeName="r" values="0;5" dur="1s" begin="1.5s" fill="freeze"/>
                  </circle>
                  <circle cx="250" cy="100" r="5" fill="#FFD700">
                    <animate attributeName="r" values="0;5" dur="1s" begin="2s" fill="freeze"/>
                  </circle>
                  <circle cx="350" cy="60" r="5" fill="#FFD700">
                    <animate attributeName="r" values="0;5" dur="1s" begin="2.5s" fill="freeze"/>
                  </circle>
                  
                  
                  <text x="75" y="275" fill="rgba(255,255,255,0.7)" fontSize="12" textAnchor="middle">Q1</text>
                  <text x="150" y="275" fill="rgba(255,255,255,0.7)" fontSize="12" textAnchor="middle">Q2</text>
                  <text x="225" y="275" fill="rgba(255,255,255,0.7)" fontSize="12" textAnchor="middle">Q3</text>
                  <text x="300" y="275" fill="rgba(255,255,255,0.7)" fontSize="12" textAnchor="middle">Q4</text>
                  
                  <text x="200" y="30" fill="white" fontSize="16" fontWeight="bold" textAnchor="middle">Revenue Growth</text>
                </svg>
              </div>
            </div>
          </div>
        </div>
        
        
        <div className="absolute top-20 left-10 w-20 h-20 bg-gradient-to-r from-yellow-400 to-orange-400 rounded-full opacity-20 animate-pulse"></div>
        <div className="absolute bottom-20 right-10 w-32 h-32 bg-gradient-to-r from-purple-400 to-pink-400 rounded-full opacity-20 animate-pulse" style={{animationDelay: '1s'}}></div>
      </section> */}
      </div>
      <Footer1/>
    </div>
  );
};

export default AboutUsPage;